const { post, get, adminCall } = require("./_utils");
const jwt = require("jsonwebtoken");
const browserStorage = require("../utils/store/browserStorage/index.js")

module.exports = {
  async checksession(token) {
    try {
      if (token) {
        let data = await get("/checkToken", {
          headers: {
            Authorization: token
          }
        });
        global.store.dispatch({
          type: "USER_AUTHENTICATED",
          payload: data
        });
      } else throw Error("User token not found");
    } catch (err) {
      if (err.response && err.response.status === 498) {
        console.log("CHECKSESSION: token expired");
        browserStorage.removeLocalItem("userToken");
      }
      return Promise.reject(err)
    }
  },

  async member(login, password) {
    try {
      let token = await post("/auth/member", { data: { login, password } })
      let payload = jwt.decode(token)
      browserStorage.setLocalItem("userToken", token)
      global.store.dispatch({ type: "USER_AUTHENTICATED", payload })
      return token
    } catch (err) {
      console.error(err)
      return Promise.reject(err)
    }
  },

  forgotPassword: (email) => get("/auth/forgotpassword", { params: { email } }),
  createPassword: ({ token, password }) => post("/auth/createPassword", {
    data: { token, password }
  }),
  resetPassword: ({ token, newPassword }) => post("/auth/resetPassword", {
    data: { token, newPassword }
  }),
  changePassword: ({ login, curPassword, newPassword }) => {
    return adminCall("auth.changePassword", {
      login,
      curPassword,
      newPassword
    });
  },
  changeLogin: ({ curLogin, newLogin, password }) => adminCall("auth.changeLogin", {
    curLogin,
    newLogin,
    password
  }),
  existLogin: (login) => adminCall("auth.existLogin", { login }),
}
